import { cn } from '@repo/ui/lib/utils'
import { FunctionComponent, useMemo } from 'react'
import { PageDto } from '../../../types/page.types'

interface Props {
  pageDto: PageDto
  quantity: number
  variant?: 'short' | 'long'
  className?: string
}

const CollectionQuantity: FunctionComponent<Props> = ({ pageDto, quantity, variant = 'short', className }) => {
  const replace = (string: string, quantity: number): string => {
    return string.replace('%1', quantity.toString())
  }

  const quantityString = useMemo(() => {
    let inputString = quantity === 1 ? pageDto.dictionary?.filter?.xitem || '%1 item' : pageDto.dictionary?.filter?.xitems || '%1 items'

    if (variant === 'long') {
      inputString = quantity === 1 ? pageDto.dictionary?.filter?.showingxitem || 'Showing %1 item' : pageDto.dictionary?.filter?.showingxitems || 'Showing %1 items'
    }

    return replace(inputString, quantity || 0)
  }, [
    pageDto.dictionary?.filter?.showingxitem,
    pageDto.dictionary?.filter?.showingxitems,
    pageDto.dictionary?.filter?.xitem,
    pageDto.dictionary?.filter?.xitems,
    quantity,
    variant,
  ])

  if (quantity === 0) {
    return null
  }

  return <p className={cn(className)}>{quantityString}</p>
}

export default CollectionQuantity
